var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMotoDelivery = function SvgMotoDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.501,
    height: 30.501,
    viewBox: "0 0 8.07 8.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M130.572 741.294h40.952v33.83h-40.952z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.952 4.035a3.917 3.917 0 0 1-3.917 3.916A3.917 3.917 0 0 1 .118 4.035 3.917 3.917 0 0 1 4.035.118a3.917 3.917 0 0 1 3.917 3.917Z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.206879,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.116 0 0 .116 4.654 6.536)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -23.084,
    cy: -11.458,
    r: 7.376,
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.92338,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.133,
    cy: -11.458,
    r: 7.376,
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.92338,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-34.39-37.368 2.512 12.72-.157 3.926-2.355 2.826.942.157 5.025-3.297 5.967.157L-8.323-6.747h6.596L8.009-22.45l1.413 4.711 4.24-2.041-4.083-5.81 4.868 1.884v-8.323l-5.81 2.67-3.612-6.124H-9.422l1.256 4.082h11.15l2.355 3.926-1.413 1.414c1.816-2.63-8.118-2.375-11.935-1.257-6.327 5.967-5.218 4.959-8.008 5.81l-3.77-3.768.315-12.72c-5.834-2.07-10.34-1.488-14.918.628z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".264581px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.233-36.426h14.918",
    style: {
      fill: "green",
      stroke: "green",
      strokeWidth: ".264581px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontWeight: 700,
      fontSize: "42.6667px",
      lineHeight: 0.65,
      fontFamily: "Arial",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      fill: "green"
    },
    transform: "translate(-66.032 -229.478) scale(.26458)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 136.457,
    y: 766.927
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "&quot"
    }
  }, "N")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMotoDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moto_delivery.831e0f4e.svg";
export { ForwardRef as ReactComponent };